import React from 'react';
import './ProductPageHeader.scss';

type Props = {
  topText: string;
  bottomText: string;
  imageUrl: string;
};

const ProductPageHeader = (props: Props) => {
  const { topText = '', bottomText = '', imageUrl = '' } = props;
  return (
    <div className="product-page-header">
      <div className="product-page-header__text">
        <div className="product-page-header__text__top">
          <p>{topText}</p>
        </div>
        <div className="product-page-header__text__bottom">
          <h3>{bottomText}</h3>
        </div>
      </div>
      <div className="product-page-header__img">
        <img src={imageUrl} alt="Product" />
      </div>
    </div>
  );
};

export default ProductPageHeader;
